const CloseIcon: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 7L23.9706 23.9706" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M7 24L23.9706 7.02944" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);
export default CloseIcon;
